import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';

import { useTranslation } from 'react-i18next';

// style
import tableIcons from '../../../../components/table/MaterialTableIcon';

// Utils
import exportCsv from '../../../../utils/export/Csv';

export default function SalinityDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('สถานี'),
            title_export: t('สถานี'),
            field: 'station_name',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.station_name}`,
          },
          {
            title: t('ค่าความเค็มสูงสุด'),
            title_export: t('ค่าความเค็มสูงสุด'),
            field: 'maxsalinity',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.maxsalinity}`,
          },
          {
            title: t('สถานะ'),
            title_export: t('สถานะ'),
            field: 'status',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.status}`,
          },
          {
            title: t('ตำบล'),
            title_export: t('ตำบล'),
            field: 'tambon',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.tambon_name}`,
          },
          {
            title: t('อำเภอ'),
            title_export: t('อำเภอ'),
            field: 'amphoe',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.amphoe_name}`,
          },
          {
            title: t('จังหวัด'),
            title_export: t('จังหวัด'),
            field: 'province',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.province_name}`,
          },
          {
            title: t('วันที่'),
            title_export: t('วันที่'),
            field: 'date_time',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.date_time}`,
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: isExport,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

SalinityDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
